import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
const privacyContent = <>
    <h3 className="text-2xl font-heading font-bold text-white mb-6" data-id="element-38">
      Política de Privacidad
    </h3>
    <div className="space-y-4 text-gray-300 font-body text-sm leading-relaxed" data-id="element-39">
      <p data-id="element-40">
        <strong className="text-white" data-id="element-41">Última actualización:</strong> Enero 2024
      </p>
      <p data-id="element-42">
        En Guía de Libertad Fiscal, respetamos tu privacidad. Esta política
        describe cómo recopilamos, usamos y protegemos tu información personal.
      </p>
      <h4 className="text-lg font-bold text-white pt-2" data-id="element-43">
        Información que Recopilamos
      </h4>
      <p data-id="element-44">
        Solo recopilamos la información necesaria para procesar tu compra:
        dirección de correo electrónico y datos de pago. No almacenamos
        información de tarjetas de crédito directamente; todos los pagos son
        procesados por proveedores de pago seguros y certificados.
      </p>
      <h4 className="text-lg font-bold text-white pt-2" data-id="element-45">
        Uso de la Información
      </h4>
      <p data-id="element-46">
        Tu información se utiliza exclusivamente para entregar el producto
        digital adquirido y enviarte confirmación de compra. No vendemos,
        alquilamos ni compartimos tu información personal con terceros con fines
        de marketing.
      </p>
      <h4 className="text-lg font-bold text-white pt-2" data-id="element-47">Cookies</h4>
      <p data-id="element-48">
        Este sitio puede utilizar cookies esenciales para el funcionamiento
        básico del sitio web. No utilizamos cookies de seguimiento publicitario.
      </p>
      <h4 className="text-lg font-bold text-white pt-2" data-id="element-49">Seguridad</h4>
      <p data-id="element-50">
        Implementamos medidas de seguridad estándar de la industria para
        proteger tu información personal contra acceso no autorizado, alteración
        o destrucción.
      </p>
      <h4 className="text-lg font-bold text-white pt-2" data-id="element-51">Tus Derechos</h4>
      <p data-id="element-52">
        Tienes derecho a solicitar acceso, corrección o eliminación de tus datos
        personales en cualquier momento.
      </p>
    </div>
  </>;
const termsContent = <>
    <h3 className="text-2xl font-heading font-bold text-white mb-6" data-id="element-53">
      Términos y Condiciones
    </h3>
    <div className="space-y-4 text-gray-300 font-body text-sm leading-relaxed" data-id="element-54">
      <p data-id="element-55">
        <strong className="text-white" data-id="element-56">Última actualización:</strong> Enero 2024
      </p>
      <p data-id="element-57">
        Al adquirir la Guía de Libertad Fiscal, aceptas los siguientes términos
        y condiciones. Por favor, léelos cuidadosamente antes de realizar tu
        compra.
      </p>
      <h4 className="text-lg font-bold text-white pt-2" data-id="element-58">Producto Digital</h4>
      <p data-id="element-59">
        La Guía de Libertad Fiscal es un producto educativo en formato digital
        (PDF). Al completar tu compra, recibirás acceso inmediato para descargar
        el material.
      </p>
      <h4 className="text-lg font-bold text-white pt-2" data-id="element-60">Uso Permitido</h4>
      <p data-id="element-61">
        La guía es para uso personal únicamente. No está permitido redistribuir,
        revender, copiar o compartir el contenido de la guía sin autorización
        expresa por escrito.
      </p>
      <h4 className="text-lg font-bold text-white pt-2" data-id="element-62">
        Naturaleza Educativa
      </h4>
      <p data-id="element-63">
        Este producto es de naturaleza educativa e informativa. No constituye
        asesoría fiscal, legal ni financiera profesional. La información
        proporcionada se basa en recursos públicos disponibles del IRS y otras
        fuentes gubernamentales.
      </p>
      <h4 className="text-lg font-bold text-white pt-2" data-id="element-64">Responsabilidad</h4>
      <p data-id="element-65">
        El usuario es responsable de verificar la exactitud de su declaración de
        impuestos. Guía de Libertad Fiscal no se hace responsable de errores en
        declaraciones individuales ni de cambios en las leyes fiscales
        posteriores a la publicación.
      </p>
      <h4 className="text-lg font-bold text-white pt-2" data-id="element-66">Reembolsos</h4>
      <p data-id="element-67">
        Debido a la naturaleza digital del producto y su entrega inmediata,
        todas las ventas son finales. No se ofrecen reembolsos una vez
        descargado el material.
      </p>
      <h4 className="text-lg font-bold text-white pt-2" data-id="element-68">Afiliación</h4>
      <p data-id="element-69">
        Este sitio y producto no están afiliados, patrocinados ni respaldados
        por el IRS, el Departamento del Tesoro de los Estados Unidos ni ninguna
        otra entidad gubernamental.
      </p>
    </div>
  </>;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-navy-dark text-gray-500 py-8 text-center text-sm border-t border-gray-800" data-id="element-70">
        <div className="max-w-6xl mx-auto px-4" data-id="element-71">
          <div className="flex justify-center gap-6 mb-4" data-id="element-72">
            <button onClick={() => setActiveModal('privacy')} className="text-gray-400 hover:text-gold-accent transition-colors underline underline-offset-2" data-id="element-73">
              Política de Privacidad
            </button>
            <span className="text-gray-700" data-id="element-74">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-gray-400 hover:text-gold-accent transition-colors underline underline-offset-2" data-id="element-75">
              Términos y Condiciones
            </button>
          </div>
          <p data-id="element-76">
            &copy; {new Date().getFullYear()} Guía de Libertad Fiscal. Todos los
            derechos reservados.
          </p>
          <p className="mt-2 text-xs" data-id="element-77">
            Este sitio no está afiliado con el IRS ni con ninguna entidad
            gubernamental. La información proporcionada es educativa.
          </p>
        </div>
      </footer>

      {/* Modal Overlay */}
      <AnimatePresence data-id="element-78">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-79">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25
        }} className="bg-navy-light border border-gray-700 rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-80">
              <div className="sticky top-0 bg-navy-light border-b border-gray-700 px-6 py-4 flex justify-end rounded-t-2xl" data-id="element-81">
                <button onClick={() => setActiveModal(null)} className="text-gray-400 hover:text-white transition-colors p-1" aria-label="Cerrar" data-id="element-82">
                  <X className="w-6 h-6" data-id="element-83" />
                </button>
              </div>
              <div className="px-6 pb-8 pt-2" data-id="element-84">
                {activeModal === 'privacy' ? privacyContent : termsContent}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}